var api = require("!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../css-loader/dist/cjs.js??ref--7-1!../../postcss-loader/src/index.js!./shift-away.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"injectType":"singletonStyleTag","attributes":{"id":"blocks-for-eventbrite-css"}};

options.insert = "head";
options.singleton = true;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;